import React, { useEffect, useRef, useState } from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

// Imperative confirm service — call confirmDelete()/confirmAction() from anywhere.
let _handler = null;

export function confirmAction(opts = {}) {
  if (!_handler) return Promise.resolve(window.confirm(opts.message || opts.title || "Are you sure?"));
  return _handler(opts);
}

export const confirmDelete = (opts = {}) =>
  confirmAction({ title: "Are you sure you want to delete?", confirmText: "Delete", destructive: true, ...opts });

// Mount once near the app root so the service is always available.
export function ConfirmHost() {
  const [state, setState] = useState(null);
  const resolver = useRef(null);
  useEffect(() => {
    _handler = (opts) => new Promise((resolve) => { resolver.current = resolve; setState(opts || {}); });
    return () => { _handler = null; };
  }, []);
  const close = (val) => { const r = resolver.current; resolver.current = null; setState(null); r && r(val); };
  return (
    <AlertDialog open={!!state} onOpenChange={(o) => { if (!o) close(false); }}>
      <AlertDialogContent className="bg-white border-[#EEEFEF] text-[#06060C]" data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{state?.title || "Are you sure?"}</AlertDialogTitle>
          {state?.message && <AlertDialogDescription className="text-[#9FA1A4]">{state.message}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel" className="bg-transparent border-[#EEEFEF] text-[#06060C]">{state?.cancelText || "Cancel"}</AlertDialogCancel>
          <AlertDialogAction data-testid="confirm-accept" onClick={() => close(true)} className={state?.destructive === false ? "bg-[#06060C] hover:bg-[#1c1c24] text-white" : "bg-rose-500 hover:bg-rose-600 text-white"}>{state?.confirmText || "Confirm"}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
